import GetCedula from "../components/GetCedula";

export default function InsertCedula() {
    return (
        <main>
            <GetCedula />
        </main>
    );
}
